module.exports = __webpack_public_path__ + "static/media/TN-Women-Tops_v2.0_OA.a96a0979.svg";